export default (
  state = { firstMenu: [], secondMenu: [], thirdMenu: [] },
  action
) => {
  switch (action.type) {
    case "SET_MENU":
      if (action.number === 1) {
        let menu = [...action.menu];
        menu.sort((a, b) => {
          if (a.order === b.order) {
            return a.title < b.title ? -1 : 1
          } else {
            return a.order < b.order ? -1 : 1
          }
        });
        return Object.assign({}, state, {
          firstMenu: menu,
        });
      } else if (action.number === 2) {
        return Object.assign({}, state, {
          secondMenu: action.menu,
        });
      } else if (action.number === 3) {
        return Object.assign({}, state, {
          thirdMenu: action.menu,
        });
      }
      break;
    case "ADD_PORTLET":
      var temp = state.firstMenu;
      addLoop(action.menu, temp);
      return Object.assign({}, state, {
        firstMenu: temp,
      });
    case "DELETE_PORTLET":
      var tempOne = state.firstMenu;
      removePorlet(action.menu, tempOne);
      var tempTwo = state.secondMenu;
      removePorlet(action.menu, tempTwo);
      var tempThree = state.thirdMenu;
      removePorlet(action.menu, tempThree);
      return Object.assign({}, state, {
        firstMenu: tempOne,
        secondMenu: tempTwo,
        thirdMenu: tempThree,
      });
      break;
    default:
      return state;
  }
};

function removePorlet(portlet, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i].object.id === portlet.id) {
      array.splice(i, 1);
      return;
    }
    if (array[i].object.children && array[i].object.children.length > 0) {
      removePorlet(portlet, array[i].object.children);
    }
  }
}

function addLoop(portlet, array) {
  for (var i = 0; i < array.length; i++) {
    if (array[i].id === portlet.parentId) {
      array[i].children.push(portlet);
    }
    if (array[i].children && array[i].children.length > 0) {
      addLoop(portlet, array[i].children);
    }
  }
}
